import i18nTrans from 'lang/i18n';

const initialized = async () => {
    return new Promise(resolve => {
        i18nTrans.on('initialized', options => {
            resolve(options);
        });
    });
};

const ERROR = async (params = {}) => {
    if (!i18nTrans.isInitialized) {
        await initialized();
    }

    return {
        UNKNOWN: {
            title: i18nTrans.t('error:unknown.title'),
            message: i18nTrans.t('error:unknown.text'),
        },
        AUTH: {
            title: i18nTrans.t('error:auth.title'),
            message: i18nTrans.t('error:auth.text'),
        },
        UNAUTHORIZED: {
            title: i18nTrans.t('error:unauthorized.title'),
            message: i18nTrans.t('error:unauthorized.text'),
        },
        NOTFOUND: {
            title: i18nTrans.t('error:notfound.title'),
            message: i18nTrans.t('error:notfound.text'),
        },
        CONFLICT: {
            title: i18nTrans.t('error:conflict.title'),
            message: i18nTrans.t('error:conflict.text'),
        },
    };
};

export default ERROR;
